/**
 * Delivery date field on floral products.
 *
 * Sets the selectable range and shows a notice when today is chosen. Kept out
 * of assets/product-custom-property.js on purpose: that component's handleInput
 * does character counting and dereferences refs.characterCount, which a date
 * field never renders.
 *
 * Classic script, not a module, matching floral-cardstock-addon.js. Loaded
 * site-wide from layout/theme.liquid, which is the only script path in this
 * theme that has proved reliable (the script_tag filter emits nothing, and raw
 * tags in a section body get stripped).
 */
(function () {
  "use strict";

  /**
   * Local-time YYYY-MM-DD. Copied from assets/gift-card-recipient-form.js.
   *
   * Deliberately NOT toISOString().slice(0,10): that is UTC, so any Dallas
   * customer ordering after 7pm CDT would have "today" resolve to tomorrow and
   * the min attribute would forbid the day they are standing in.
   */
  function localYMD(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  function wire(input) {
    if (input.dataset.deliveryDateWired === "1") return;
    input.dataset.deliveryDateWired = "1";

    var today = new Date();
    var maxDays = parseInt(input.dataset.maxDaysOut, 10);
    if (!Number.isFinite(maxDays) || maxDays <= 0) maxDays = 60;
    var max = new Date();
    max.setDate(today.getDate() + maxDays);

    var todayYMD = localYMD(today);
    input.setAttribute("min", todayYMD);
    input.setAttribute("max", localYMD(max));

    var wrapper = input.parentElement;
    var notice = wrapper && wrapper.querySelector("[data-delivery-date-notice]");
    var noticeText = notice && notice.querySelector("span");

    function update() {
      if (!notice || !noticeText) return;
      var isToday = input.value === todayYMD;
      if (isToday) {
        noticeText.textContent = input.dataset.sameDayNotice || "";
        notice.hidden = false;
      } else {
        notice.hidden = true;
      }
    }

    input.addEventListener("change", update);
    input.addEventListener("input", update);
    update();
  }

  /* The reveal toggle lived here until 2026-09-14. It stripped its own name so
     the checkbox never became a line item property, and disabled the date input
     while hidden so an empty required value could not block the form. Both were
     the right calls for an OPTIONAL date. The date is required now, so the
     toggle is gone and the field is simply always there. */

  function scan(root) {
    (root || document).querySelectorAll("[data-delivery-date-input]").forEach(wire);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(); });
  } else {
    scan();
  }

  // Quick-add and variant changes re-render product markup, so re-scan rather
  // than assuming one pass at load is enough.
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1) scan(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
